import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { usePortalPlaylists } from '../hooks/usePortalPlaylists';
import { streamingSectionPath } from '../streamingPaths';
import { streamingBlockMessages as messages } from '../streamingBlockMessages';
import { StreamingBlock } from '../parts/StreamingBlock';
import { PlaylistsTable } from '../parts/PlaylistsTable';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from '../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */

const BLOCK_ROWS = 4;

interface PlaylistsBlockProps {
  accountId: number;
  days: number;
  onNavigate: (path: string) => void;
}

/** The top four playlists (design b1). */
const PlaylistsBlockComponent: React.FC<PlaylistsBlockProps> = ({ accountId, days, onNavigate }) => {
  const intl = useIntl();
  const { playlists, isLoading, error, retry } = usePortalPlaylists(accountId);
  const top = useMemo(() => playlists.slice(0, BLOCK_ROWS), [playlists]);

  return (
    <StreamingBlock
      title={intl.formatMessage(messages.playlists)}
      meta={intl.formatMessage(messages.playlistsCount, { count: playlists.length })}
      moreLabel={intl.formatMessage(messages.allPlaylists)}
      onMore={() => onNavigate(streamingSectionPath('playlists', days))}
      isLoading={isLoading}
      error={error}
      retry={retry}
      testId="streaming-block-playlists"
    >
      {top.length === 0 ? (
        <p className={styles.faint}>{intl.formatMessage(messages.emptyList)}</p>
      ) : (
        <PlaylistsTable playlists={top} />
      )}
    </StreamingBlock>
  );
};

export const PlaylistsBlock = TypedMemo(PlaylistsBlockComponent);
